// import * as XLSX from 'xlsx';

// async function fetchCityData() {
//   const response = await fetch('https://www.seminargo.at/wp-content/uploads/2023/04/OrteInOesterreich.xlsx');

//   const data = await response.arrayBuffer();
//   // console.log(data)
//   const workbook = XLSX.read(data, { type: 'array' });
//   const sheetName = workbook.SheetNames[0];
//   const worksheet = workbook.Sheets[sheetName];
//   const cityData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: 'NULL' });
//   const cityObjects = cityData.map(([id, name]) => {
//     return  {id, name};
//   });
//   cityObjects.shift(); // remove first row, where the column names are
//   // console.log(cityObjects)
//   return cityObjects;
// }

export default async function Autocomplete() {
  // const suggestions = await fetchCityData();
  const suggestions = [{id: 1, name: 'Wien'}, {id: 2, name: 'Burgenland'}, {id: 3, name: 'Kärnten'}, {id: 4, name: 'Niederösterreich'}, {id: 5, name: 'Oberösterreich'}, {id: 6, name: 'Salzburg'}, {id: 7, name: 'Steiermark'}, {id: 8, name: 'Tirol'}, {id: 9, name: 'Vorarlberg'}]
  // console.log(suggestions)
  return suggestions;
}

